import React, {Component} from 'react';
import Intestazione from './components_novel/intestazione';
import Piedone from './components/piedone';
import Navbar from './components/navbar';
import Seo, {siteUrl} from './components/seo';

import logo from './images/Logo-Verso-Hemelslinn-2.webp';
import intestazioneBackgroundImage from './images/verso-hemelslinn-sfondo-2.webp';

const pagePath = '/cos-e-verso-hemelslinn/';
const pageTitle = 'Verso Hemelslinn: space opera romantica italiana';
const pageDescription =
  'Scopri Verso Hemelslinn, una space opera romantica italiana senza alieni: un romanzo di fantascienza su scelte, legami, amore e futuro.';

const crowdfundingUrl = 'https://hemelslinn.s.gy/vh-web-hem-land';

const intestazioneBackgroundStyle = {
  backgroundImage: `url(${intestazioneBackgroundImage})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center center',
  backgroundAttachment: 'fixed',
  height: '300px',
};

const faqs = [
  {
    question: 'Verso Hemelslinn è un romanzo di fantascienza?',
    answer:
      'Sì. È un romanzo di fantascienza ambientato in un futuro caratterizzato da viaggi spaziali, tecnologie avanzate e insediamenti umani lontani dalla Terra.',
  },
  {
    question: 'È anche una storia d’amore?',
    answer:
      'La dimensione romantica è una componente fondamentale della storia, ma si sviluppa insieme alla trama fantascientifica, alle scelte dei personaggi e agli eventi del viaggio.',
  },
  {
    question: 'Nel romanzo ci sono alieni?',
    answer:
      'No. Verso Hemelslinn è una storia di fantascienza senza alieni. Il romanzo concentra l’attenzione sull’umanità, sul suo futuro e sulle relazioni tra le persone.',
  },
  {
    question: 'È una space opera italiana?',
    answer:
      'Sì. Verso Hemelslinn è una space opera italiana scritta da Maurizio Feruglio e sviluppata come progetto editoriale indipendente.',
  },
  {
    question: 'È necessario conoscere molta fantascienza per leggerlo?',
    answer:
      'No. Gli elementi fantascientifici sono parte del mondo narrativo, ma la storia è costruita per essere seguita anche da chi è soprattutto interessato ai personaggi, ai rapporti umani e alle loro scelte.',
  },
  {
    question: 'Come viene pubblicato il romanzo?',
    answer:
      'Il progetto editoriale di Verso Hemelslinn è sostenuto attraverso una campagna di crowdfunding dedicata alla realizzazione e alla pubblicazione dell’edizione fisica.',
  },
];

export function AddLibrary(urlOfTheLibrary) {
  const script = document.createElement('script');
  script.src = urlOfTheLibrary.startsWith('/') ? urlOfTheLibrary : '/' + urlOfTheLibrary;
  script.async = true;
  document.body.appendChild(script);
}

class CoseVersoHemelslinn extends Component {
  state = {
    aNavbarLinks: [
      {id: 0, linkHref: '/', linkNome: 'ROMANZO'},
      {id: 1, linkHref: '/summary', linkNome: 'SOMMARIO'},
      {id: 2, linkHref: '/articoli', linkNome: 'ARTICOLI'},
    ],
  };

  render() {
    const pageJsonLd = {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'WebPage',
          '@id': `${siteUrl}${pagePath}#webpage`,
          url: `${siteUrl}${pagePath}`,
          name: pageTitle,
          description: pageDescription,
          isPartOf: {
            '@id': `${siteUrl}/#website`,
          },
          about: {
            '@id': `${siteUrl}/#book`,
          },
          inLanguage: 'it-IT',
        },
        {
          '@type': 'Book',
          '@id': `${siteUrl}/#book`,
          name: 'Verso Hemelslinn',
          author: {
            '@id': `${siteUrl}/maurizio-feruglio/#person`,
          },
          publisher: {
            '@id': 'https://www.eliosfera.it/#organization',
          },
          inLanguage: 'it-IT',
          genre: ['Space opera', 'Fantascienza romantica', 'Fantascienza italiana'],
          description: pageDescription,
          image: `${siteUrl}/images/copertina-verso-hemelslinn.webp`,
        },
        {
          '@type': 'Person',
          '@id': `${siteUrl}/maurizio-feruglio/#person`,
          name: 'Maurizio Feruglio',
          url: `${siteUrl}/maurizio-feruglio/`,
        },
        {
          '@type': 'Organization',
          '@id': 'https://www.eliosfera.it/#organization',
          name: 'Eliosfera Editrice',
          url: 'https://www.eliosfera.it',
        },
        {
          '@type': 'FAQPage',
          '@id': `${siteUrl}${pagePath}#faq`,
          mainEntity: faqs.map((faq) => ({
            '@type': 'Question',
            name: faq.question,
            acceptedAnswer: {
              '@type': 'Answer',
              text: faq.answer,
            },
          })),
        },
        {
          '@type': 'BreadcrumbList',
          '@id': `${siteUrl}${pagePath}#breadcrumb`,
          itemListElement: [
            {
              '@type': 'ListItem',
              position: 1,
              name: 'Verso Hemelslinn',
              item: `${siteUrl}/`,
            },
            {
              '@type': 'ListItem',
              position: 2,
              name: 'Cos’è Verso Hemelslinn',
              item: `${siteUrl}${pagePath}`,
            },
          ],
        },
      ],
    };

    return (
      <>
        <div className="page">
          <Seo
            title={pageTitle}
            description={pageDescription}
            path={pagePath}
            image="/images/copertina-verso-hemelslinn.webp"
            jsonLd={pageJsonLd}
          />
          <Navbar
            linkSito="/"
            logo={logo}
            deskLogo="Logo di Verso Hemelslinn"
            brandName="Verso Hemelslinn"
            aNavbarLinks={this.state.aNavbarLinks}
          />
          <div id="pagina" className="cose-page">
            <Intestazione
              pagina="COS’È VERSO HEMELSLINN"
              backgroundStyle={intestazioneBackgroundStyle}
              titolo="SPACE OPERA ROMANTICA ITALIANA"
              titoloAs="p"
              romanzo="senza alieni, con il cuore vicino"
              autore="VERSO HEMELSLINN"
            />

            <section className="ftco-section seo-pillar-section">
              <div className="container">
                <article className="seo-pillar-shell">
                  <p className="landing-kicker">Cos’è Verso Hemelslinn</p>
                  <h1>Cos’è Verso Hemelslinn: una space opera romantica italiana, senza alieni</h1>
                  <p className="seo-pillar-lead">
                    <strong>Verso Hemelslinn</strong> è un romanzo di fantascienza romantico ambientato in un futuro lontano, dove il viaggio nello spazio diventa anche un viaggio tra le persone, le loro scelte e i legami che cercano di salvare.
                  </p>
                  <p>
                    È una <strong>space opera romantica italiana</strong> che mette al centro gli esseri umani. Non ci sono civiltà aliene da combattere, creature extraterrestri o invasioni provenienti da mondi sconosciuti. Ci sono uomini e donne che attraversano lo spazio portando con sé speranze, paure, responsabilità e sentimenti difficili da ignorare.
                  </p>
                  <blockquote>
                    <p>Perché il viaggio più importante potrebbe non essere quello verso un altro pianeta, ma quello che separa due persone.</p>
                  </blockquote>

                  <h2>Una space opera romantica</h2>
                  <p>
                    La space opera racconta spesso grandi viaggi interstellari, civiltà future, astronavi, conflitti e mondi lontani.
                  </p>
                  <p>
                    In <em>Verso Hemelslinn</em>, questi elementi formano lo scenario di una storia in cui l’avventura fantascientifica si intreccia con una dimensione più intima: l’amore, la perdita, il tempo, la distanza e le conseguenze delle decisioni individuali.
                  </p>
                  <p>
                    La componente romantica non è separata dalla trama fantascientifica. Ne è parte integrante. Le relazioni tra i personaggi influenzano le loro scelte, mentre gli eventi del viaggio trasformano il modo in cui comprendono sé stessi e gli altri.
                  </p>
                  <p>
                    <em>Verso Hemelslinn</em> è quindi una space opera romantica, ma non una storia d’amore semplicemente trasferita nello spazio. È un romanzo in cui fantascienza e sentimento agiscono l’una sull’altro.
                  </p>

                  <h2>Un romanzo di fantascienza senza alieni</h2>
                  <p>
                    <em>Verso Hemelslinn</em> appartiene a una fantascienza senza alieni, costruita intorno all’essere umano e al suo futuro.
                  </p>
                  <p>
                    L’universo del romanzo è fatto di pianeti, rotte spaziali, tecnologie avanzate, missioni e ambienti lontani dalla Terra. Ma il centro della narrazione rimane umano.
                  </p>
                  <p>
                    La domanda non è soltanto che cosa potremo raggiungere grazie alla tecnologia. La domanda è che cosa resterà di noi quando le distanze diventeranno enormi, quando una scelta non potrà essere annullata e quando il tempo stesso sembrerà separarci dalle persone che amiamo.
                  </p>
                  <blockquote>
                    <p>Qui non troverai alieni. Troverai esseri umani.</p>
                  </blockquote>

                  <h2>Un viaggio nello spazio e tra le persone</h2>
                  <p>
                    Il viaggio verso Hemelslinn non rappresenta soltanto uno spostamento attraverso il cosmo. È una direzione, una promessa e, per alcuni personaggi, una possibilità di ricominciare. Per altri può diventare una rinuncia, una separazione o una scelta irreversibile.
                  </p>
                  <p>
                    Lo spazio amplifica ogni cosa. Amplifica la solitudine, perché non esiste un luogo vicino in cui tornare. Amplifica il tempo, perché ogni attesa può diventare definitiva. Amplifica le relazioni, perché una parola non detta o una decisione rimandata possono attraversare distanze impossibili da colmare.
                  </p>

                  <h2>Fantascienza, sentimento e scelte difficili</h2>
                  <p>
                    <em>Verso Hemelslinn</em> nasce dall’incontro tra tre dimensioni narrative: l’avventura spaziale, il romanzo romantico e le scelte morali e personali.
                  </p>
                  <p>
                    Il romanzo non chiede soltanto che cosa accadrà. Chiede che cosa faremmo noi al posto dei personaggi.
                  </p>
                  <ul>
                    <li>Sceglieremmo la missione o la persona che amiamo?</li>
                    <li>Accetteremmo di partire sapendo che qualcuno potrebbe non aspettarci?</li>
                    <li>Quanto lontano saremmo disposti ad andare per conservare un legame?</li>
                  </ul>

                  <h2>Una nuova space opera italiana</h2>
                  <p>
                    <em>Verso Hemelslinn</em> si inserisce nel panorama della fantascienza italiana con un’identità precisa. È una nuova space opera italiana che costruisce il proprio spazio narrativo partendo dai personaggi e dalle loro motivazioni.
                  </p>
                  <p>
                    La dimensione spettacolare esiste, ma non sostituisce quella emotiva. Astronavi, pianeti e tecnologie acquistano significato attraverso lo sguardo di chi li vive.
                  </p>
                  <blockquote>
                    <p>L’obiettivo non è mostrare quanto sia grande l’universo. È mostrare quanto possa diventare fragile una persona al suo interno.</p>
                  </blockquote>

                  <h2>Un romanzo di fantascienza nato attraverso il crowdfunding</h2>
                  <p>
                    <em>Verso Hemelslinn</em> è anche un progetto editoriale indipendente sostenuto attraverso una <a href={crowdfundingUrl}>campagna crowdfunding del romanzo</a>.
                  </p>
                  <p>
                    Il crowdfunding non rappresenta soltanto un sistema per finanziare la produzione del libro. È un modo per coinvolgere i lettori prima della pubblicazione definitiva e permettere loro di accompagnare il romanzo nella sua trasformazione in un’edizione fisica.
                  </p>
                  <p>
                    Chi partecipa non acquista semplicemente un prodotto già presente sugli scaffali. Contribuisce alla realizzazione editoriale del progetto e diventa parte del suo percorso.
                  </p>

                  <h2>A chi può interessare Verso Hemelslinn</h2>
                  <p><em>Verso Hemelslinn</em> può interessare a chi cerca:</p>
                  <ul>
                    <li>una space opera romantica incentrata sui personaggi;</li>
                    <li>un romanzo di fantascienza romantico e adulto;</li>
                    <li>una storia ambientata nello spazio senza civiltà aliene;</li>
                    <li>una fantascienza attenta alle emozioni e alle relazioni;</li>
                    <li>un’avventura spaziale italiana;</li>
                    <li>un romanzo sui legami, sul tempo e sulle scelte irreversibili;</li>
                    <li>un progetto editoriale indipendente nato attraverso il crowdfunding.</li>
                  </ul>
                  <p>
                    Non è necessario essere lettori abituali di fantascienza. Il romanzo può essere letto anche come una storia di persone costrette a confrontarsi con distanze, responsabilità e sentimenti che la tecnologia non è in grado di risolvere.
                  </p>

                  <h2>Perché il titolo “Verso Hemelslinn”</h2>
                  <p>
                    La parola “verso” indica una direzione, ma non garantisce l’arrivo. Racchiude l’idea del movimento, dell’attesa e di qualcosa che deve ancora compiersi.
                  </p>
                  <p>
                    Hemelslinn è una destinazione, ma anche ciò che quella destinazione rappresenta per ciascun personaggio. Può essere un luogo da raggiungere, una speranza, una fuga o la promessa di una vita diversa.
                  </p>
                  <p>
                    Il titolo non racconta soltanto dove stanno andando i protagonisti. Racconta ciò verso cui tendono.
                  </p>

                  <h2>Scopri il mondo di Verso Hemelslinn</h2>
                  <div className="seo-pillar-grid">
                    <div className="seo-pillar-card">
                      <h3>Leggi il sommario</h3>
                      <p>
                        Consulta il <a href="/summary">sommario di Verso Hemelslinn</a> per scoprire la struttura del romanzo e attraversarne i capitoli senza anticipazioni decisive sulla trama.
                      </p>
                    </div>
                    <div className="seo-pillar-card">
                      <h3>Esplora gli articoli</h3>
                      <p>
                        Negli <a href="/articoli">articoli sulla scrittura di Verso Hemelslinn</a> trovi approfondimenti sulla scrittura, sui personaggi, sul punto di vista, sulla costruzione delle scene e sui temi narrativi del romanzo.
                      </p>
                    </div>
                    <div className="seo-pillar-card">
                      <h3>Segui il progetto</h3>
                      <p>
                        Visita la <a href={crowdfundingUrl}>campagna crowdfunding del romanzo</a> per conoscere il percorso editoriale del libro, gli aggiornamenti e le modalità con cui è possibile sostenere la sua pubblicazione.
                      </p>
                    </div>
                  </div>

                  <h2>Domande frequenti</h2>
                  <div className="seo-pillar-faq">
                    {faqs.map((faq) => (
                      <details key={faq.question}>
                        <summary>{faq.question}</summary>
                        <p>{faq.answer}</p>
                      </details>
                    ))}
                  </div>

                  <div className="seo-pillar-actions">
                    <a className="btn btn-primary" href={crowdfundingUrl}>
                      Sostieni la campagna
                    </a>
                    <a className="btn btn-info" href="/summary">
                      Leggi il sommario
                    </a>
                  </div>
                </article>
              </div>
            </section>

            <Piedone
              piedoneCallToAction="Ogni rotta comincia da una scelta. Qui puoi scoprire che tipo di viaggio ti aspetta."
              piedoneLinkTermConditions=""
              piedoneLinkCookies="/cookies"
              piedoneLinkPrivacy="/privacy"
              piedoneIframe=""
              piedoneTwitter="https://x.com/Hemelslinn"
              piedoneInstagram="https://www.instagram.com/versohemelslinn/"
              piedoneFacebook="https://www.facebook.com/hemelslinn"
              piedoneTiktok="https://www.tiktok.com/@hemelslinn"
              piedoneDiscord=""
              piedonePinterest="https://it.pinterest.com/hemelslinn/"
              piedoneOpensea=""
              piedoneEliosfera="https://www.eliosfera.it/maurizio-feruglio-verso-hemelslinn-copertina-rigida-libro"
              piedoneYoutube="https://www.youtube.com/@VersoHemelslinn"
              piedoneCopyright="Eliosfera Editrice &copy;"
              piedoneCopyrightDisclaimer="Tutti i diritti riservati"
              piedoneCCBY='Template basato su <i class="icon-heart" aria-hidden="true"></i> <a href="https://colorlib.com" target="_blank">Colorlib</a>'
            />
          </div>

          {AddLibrary('js/jquery.min.js')}
          {AddLibrary('js/jquery-migrate-3.0.1.min.js')}
          {AddLibrary('js/jquery.waypoints.min.js')}
          {AddLibrary('js/jquery.stellar.min.js')}
          {AddLibrary('js/owl.carousel.min.js')}
          {AddLibrary('js/aos.js')}
          {AddLibrary('js/scrollax.min.js')}
          {AddLibrary('js/main.js')}
        </div>
      </>
    );
  }
}

export default CoseVersoHemelslinn;
